module.exports = __webpack_public_path__ + "static/media/github.ab7c4984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Follow/github.svg
// module id = 626
// module chunks = 0